export default "__VITE_ASSET__DuPMwDPs__"